<template>
  <section class="top">
    <div class="top_in">
      <h1 class="top_ttl">
        <img
          src="../assets/bs_logo.png"
          alt="睡眠偏差値forBiz"
          class="top_ttlImg"
        />
      </h1>
      Language:
      <v-select
        :items="getLanguages"
        :value="getLanguage"
        @input="updateLanguage"
        solo
        class="language"
      ></v-select>
      <div v-if="getLanguage == '日本語'">
        <h2 class="top_copy">
          <span class="top_copyLine">きちんと睡眠、</span>
          <span class="top_copyLine">とれていますか？</span>
        </h2>
        <div class="top_desc">
          <p class="top_descBlk">
            現代人は、忙しい。
            <br />世界一睡眠時間が短いといわれる日本人ですが、睡眠不足だとわかっていても十分な睡眠をとることは難しく、睡眠負債がたまる一方です。
          </p>
          <p class="top_descBlk">
            この「睡眠偏差値®forBiz」は睡眠に関する自覚症状や睡眠習慣などの幅広い視点で主観的評価を定量化し、「偏差値」として数値化することで、日本人全体の中での相対的な睡眠状態を把握することを可能にしました。
          </p>
          <p class="top_descBlk">
            また、専門家監修のアドバイスも受けることができます。
            <br />さぁ、あなたも最高の睡眠®を。
          </p>
          <div class="top_lead">
            <button class="btn_next" v-on:click="toAuthPath">
              <span v-if="getLoginState == false"></span>ログイン
            </button>
          </div>
        </div>
      </div>

      <div v-if="getLanguage == 'English'">
        <h2 class="top_copy">
          <span class="top_copyLine">Are you gettting enouth sleep?</span>
        </h2>
        <div class="top_desc">
          <p class="top_descBlk">
            People today are busy.
            <br />Japanese people are said to have the shortest sleep time in
            the world, but even if they know they are lacking sleep, it's
            difficult for them to get enough sleep and they accumulate sleep
            debt.
          </p>
          <p class="top_descBlk">
            The "Sleep Deviation Score® for Biz" quantifies subjective
            evaluations from a wide range of perspectives, including subjective
            symptoms and sleep habits, and converts them into numerical values
            as "deviation score" making it possible to grasp the relative sleep
            conditions among all Japanese people.
          </p>
          <p class="top_descBlk">
            You can also get advice from expert supervision.
            <br />Now let's have the best sleep.
          </p>
          <div class="top_lead">
            <button class="btn_next" v-on:click="toAuthPath">
              <span v-if="getLoginState == false"></span>Login
            </button>
          </div>
        </div>
      </div>

      <div v-if="getLanguage == '中文'">
        <h2 class="top_copy">
          <span class="top_copyLine">睡眠充足吗?</span>
        </h2>
        <div class="top_desc">
          <p class="top_descBlk">
            现代人相当忙碌。
            <br />据说日本人的睡眠时间是世界上最短的，但即使知道自己睡眠不足，也很难睡够，还积累了睡眠债。
          </p>
          <p class="top_descBlk">
            "睡眠偏差值®forBiz"从睡眠相关的主观症状和睡眠习惯等多个角度出发，将主观评价量化为
            "偏差值"，以便了解自己相对于全日本人的睡眠状况。
          </p>
          <p class="top_descBlk">
            您还可以得到专家的建议。
            <br />现在，您也可以拥有最好的睡眠®。
          </p>
          <div class="top_lead">
            <button class="btn_next" v-on:click="toAuthPath">
              <span v-if="getLoginState == false"></span>登录
            </button>
          </div>
        </div>
      </div>
    </div>
    <footer class="footer">
      <div class="footer_in">
        <div class="footer_1">
          <p>
            <span class="footer_serviceTtl">睡眠偏差値® for Biz</span>
            <span class="footer_serviceUrl">suiminhensachi.com</span>
          </p>
        </div>
        <div class="footer_2">
          <ul class="footer_nav">
            <li class="footer_navItem" v-on:click="toTermPath">
              <div v-if="getLanguage == '日本語'">
                <a>利用規約</a>
              </div>
              <div v-if="getLanguage == 'English'">
                <a>Terms of service</a>
              </div>
              <div v-if="getLanguage == '中文'">
                <a>使用条款</a>
              </div>
            </li>
          </ul>
        </div>
        <div class="footer_3">
          <dl>
            <dt>
              ver.1.2.2
              <span v-if="getLanguage == '日本語'"> 運営会社 </span>
              <span v-if="getLanguage == 'English'"> Operating Company </span>
              <span v-if="getLanguage == '中文'"> 管理公司 </span>
            </dt>
            <dd>
              <a href="https://brain-sleep.com/">
                <img
                  src="../assets/bs-logo-company.png"
                  class="footer_bslogoImg"
                  alt="BRAIN SLEEP"
                />
              </a>
            </dd>
          </dl>
        </div>
      </div>
    </footer>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";

export default {
  created: function() {
    document.getElementsByTagName("html")[0].classList.add("page-entry");
  },
  computed: {
    returnLanguage() {
      return this.getLanguage;
    },
    ...mapGetters(["getFormState", "getLanguages", "getLanguage"]),
  },
  methods: {
    ...mapMutations(["setValueToLanguage"]),
    toForm() {
      this.$router.push("form");
    },
    toAuthPath() {
      if (this.$route.query.logintype == "id") {
        this.$router.push({path: "/auth", query: {logintype: "id"}});
      } else {
        this.$router.push("/auth");
      }
      
    },
    toTermPath() {
      this.$router.push("/terms");
    },
    updateLanguage(e) {
      this.$store.commit("setValueToLanguage", e);
    },
  },
};
</script>
<style lang="scss">
$xs: "320px";
$sm: "480px";
$md: "800px";
$lg: "1024px";
.top_in {
  background-color: #fff;
}

.top_in {
  background-color: #fff;
}
.footer {
  background-color: #fff;
}

.page-entry {
  background-color: #fff;
}
.btn_next {
  display: inline-block;
  color: #fff;
  font-size: 18px;
  padding: 12px;
  min-width: 160px;
  text-align: center;
  background-color: #ff7600;
  border-radius: 28px;
  margin-top: 24px;
  box-shadow: 0 2px 4px 0px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    width: 12px;
    height: 20px;
    background: url(../assets/icon_next.svg) center center no-repeat;
    right: 24px;
    top: 15px;
  }
  &:hover {
    opacity: 0.9;
  }

  @media screen and (max-width: $sm) {
    display: block;
    width: 100%;
  }
}

.top {
  background-color: white;
  min-height: 100vh;
  overflow: hidden;
  &_in {
    max-width: 1280px;
    margin: 0 auto;
    padding: 100px 48px;
    position: relative;
    &::after {
      position: absolute;
      content: "";
      width: 800px;
      height: 800px;
      background: url(../assets/top_bg.png) center center no-repeat;
      background-size: 720px;
      right: -100px;
      top: -30px;
      z-index: 0;
      @media screen and (max-width: $lg) {
        width: 100vmin;
        height: 100vmin;
        right: -30vmin;
        top: -12vmin;
        background-size: 60vmin;
      }
    }

    @media screen and (max-width: $sm) {
      padding: 12px 0 0;
    }
  }
  &_company {
    @media screen and (max-width: $md) {
      padding-left: 24px;
    }
  }
  &_bsLogo {
    width: 140px;
    vertical-align: middle;
    margin-left: -5px;
    @media screen and (max-width: $md) {
      width: 120px;
      margin-left: -4px;
      margin-bottom: 2px;
    }
  }
  &_cross {
    vertical-align: middle;
    margin: 0 16px 0 12px;
    @media screen and (max-width: $md) {
      margin: 10px;
    }
  }
  &_ntteLogo {
    vertical-align: middle;
    @media screen and (max-width: $md) {
      width: 84px;
    }
  }
  &_ttl {
    position: relative;
    z-index: 1;
    @media screen and (max-width: $sm) {
      padding: 0 24px 0;
    }
  }

  &_ttlImg {
    width: 286px;
    @media screen and (max-width: $lg) {
      width: 200px;
    }
    @media screen and (max-width: $sm) {
      width: 150px;
    }
  }

  &_copy {
    font-size: 28px;
    color: #1d64a1;
    letter-spacing: 0.2em;
    margin-top: 48px;
    position: relative;
    z-index: 1;
    @media screen and (max-width: $sm) {
      padding: 0 20px;
      font-size: 20px;
      margin-top: 24px;
    }
  }

  &_copyLine {
    display: block;

    @media screen and (max-width: $sm) {
      display: block;
    }
  }

  &_desc {
    margin-top: 24px;
    letter-spacing: 0.05em;
    width: 50%;
    position: relative;
    z-index: 1;
    @media screen and (max-width: $lg) {
      width: 400px;
    }
    @media screen and (max-width: $md) {
      width: 80%;
    }
    @media screen and (max-width: $sm) {
      width: 100%;
      padding: 22px;
      margin-top: 0;
      text-align: justify;
    }
  }

  &_descBlk {
    color: #1d64a1;
    font-size: 14px;
    line-height: 2;
    background-color: rgba(255, 255, 255, 0.8);
    padding-right: 1em;

    @media screen and (max-width: $sm) {
      font-size: 14px;
      line-height: 1.8;
    }

    & + & {
      margin-top: 1em;
    }
  }
  &_lead {
    .btn_next {
      min-width: 280px;
    }
  }
}
.v-application a {
  color: inherit !important;
}
.footer {
  line-height: 1;
  color: #808080;

  @media screen and (max-width: $sm) {
    padding: 24px;
  }

  &_in {
    width: 100%;
    padding: 0px 48px 36px;
    max-width: 1280px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    @media screen and (max-width: $md) {
      display: block;
      padding: 0;
      text-align: center;
    }
  }

  &_serviceTtl {
    display: block;
    font-weight: bold;
    font-size: 14px;
  }

  &_serviceUrl {
    display: block;
    font-weight: normal;
    font-size: 12px;
    margin-top: 4px;
    letter-spacing: 0.05em;
  }

  &_nav {
    list-style-type: none;
    display: flex;
    @media screen and (max-width: $lg) {
      display: block;
    }
    @media screen and (max-width: $md) {
      display: flex;
      margin-top: 24px;
      justify-content: center;
    }
  }

  &_navItem {
    font-size: 12px;
    padding: 0 36px;
    line-height: 1;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      width: 6px;
      height: 6px;
      top: 4px;
      margin-left: 4px;
      border-right: solid 1px #ccc;
      border-top: solid 1px #ccc;
      transform: rotate(45deg);
    }
    a {
      color: #808080;
      text-decoration: none;
      position: relative;
    }
    & + & {
      ::before {
        content: "";
        position: absolute;
        width: 8px;
        height: 1px;
        left: -40px;
        top: 6px;
        border-top: solid 1px #ccc;
        border-right: solid 1px #ccc;
        @media screen and (max-width: $md) {
          left: -34px;
        }
      }
      @media screen and (min-width: $md) and (max-width: $lg) {
        margin-top: 4px;
      }
      @media screen and (max-width: $md) {
        padding: 0px 24px;
      }
    }
  }

  &_bslogo {
    display: block;
  }

  &_bslogoImg {
    width: 140px;
    vertical-align: middle;
    margin-bottom: 2px;

    @media screen and (max-width: $md) {
      padding: 0;
      text-align: center;
      font-size: 20px;
      width: 140px;
    }
  }

  &_nttelogoImg {
    width: 100px;
    vertical-align: middle;
    @media screen and (max-width: $md) {
      width: 100px;
    }
  }

  &_1 {
    width: 20%;
    > p {
      margin-bottom: 0;
    }
    @media screen and (max-width: $md) {
      width: 100%;
    }
  }
  &_2 {
    width: 30%;
    > p {
      margin-bottom: 0;
    }
    @media screen and (max-width: $md) {
      width: 100%;
    }
  }

  &_3 {
    width: 50%;
    text-align: right;
    @media screen and (max-width: $md) {
      width: 100%;
    }
    dt,
    dd {
      display: inline-block;
      vertical-align: middle;
      font-size: 12px;
    }
    dt {
      margin-right: 16px;
    }
    dd + dd {
      margin-left: 16px;
    }
    @media screen and (max-width: $md) {
      text-align: center;
      margin-top: 24px;
      dt {
        display: block;
        margin: 0 0 8px 0;
      }
      dd:first-child {
        margin-left: 0;
      }
    }
  }

  &_desc {
    width: 50%;
  }
}
.language {
  width: 300px;
}
</style>
